const defaultState = () => ({
    results: [],
    test: null,
    users: [],
    test_result_history: []
});
export default defaultState;
